<div class="fr8bot-alert-transparent {{ COLORS_MAP[color()] }}">
  <div class="fr8bot-alert-transparent__icon">
    <ng-content select="[icon]"></ng-content>
  </div>

  <div class="fr8bot-alert-transparent__text">
    <ng-content></ng-content>
  </div>
</div>
